import { Form, Input, Select } from "antd";

const { Option } = Select;

/**
 * Reusable Member Form Component
 * @param {Object} member - Member data object with username and roles
 * @param {Function} onChange - Handler for form changes (receives partial update object)
 * @param {Function} translate - Translation function
 * @param {boolean} isEditing - Whether this is edit mode (username disabled)
 */
export const MemberForm = ({
  member,
  onChange,
  translate = (key) => key,
  isEditing = false,
}) => {
  return (
    <Form layout="vertical">
      <Form.Item label={translate("organizations.username")}>
        <Input
          name="username"
          value={member.username}
          disabled={isEditing}
          onChange={(e) => onChange({ username: e.target.value })}
        />
      </Form.Item>

      <Form.Item label={translate("organizations.roles")}>
        <Select
          mode="multiple"
          placeholder={translate("organizations.selectRoles")}
          value={member.roles}
          onChange={(roles) => onChange({ roles })}
          style={{ width: "100%" }}
        >
          <Option value="admin">{translate("organizations.admin")}</Option>
          <Option value="operator">
            {translate("organizations.operator")}
          </Option>
          <Option value="log_manager">
            {translate("organizations.logManager")}
          </Option>
        </Select>
      </Form.Item>
    </Form>
  );
};
